import { fetchAuthSession } from "aws-amplify/auth";
import { post, put } from "aws-amplify/api";
import { useMutation, useQueryClient } from "react-query";
import {
  CAREGIVERS_CGID_QUERY_KEY,
  CAREGIVERS_PID_KEY,
} from "./useCareGiversQuery";

export const useCareGiverPostMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formInputs) => {
      const session = await fetchAuthSession();
      const { body } = await post({
        apiName: "careprovidersapi",
        path: "/caregivers",
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: formInputs,
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CAREGIVERS_CGID_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [CAREGIVERS_PID_KEY] });
    },
  });
};

export const useCareGiverInvitePostMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formInputs) => {
      const session = await fetchAuthSession();
      const { body } = await post({
        apiName: "careprovidersapi",
        path: "/caregivers/invite",
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: formInputs,
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CAREGIVERS_CGID_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [CAREGIVERS_PID_KEY] });
    },
    retry: false
  });
};

export const useCareGiverPutMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formInputs) => {
      const session = await fetchAuthSession();
      const { body } = await put({
        apiName: "careprovidersapi",
        path: "/caregivers",
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: formInputs,
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CAREGIVERS_CGID_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [CAREGIVERS_PID_KEY] });
    },
  });
};
